import onGetTableCustomizationsByTypeId from './onGetTableCustomizationsByTypeId';
import onUpdateTableCustomizationsByTypeId from './onUpdateTableCustomizationsByTypeId';

export default {
  onGetTableCustomizationsByTypeId,
  onUpdateTableCustomizationsByTypeId,
};
